<template>
    <div class="form-input" :class="[classString, {'error': error}, {'locked': element.locked === true, 'unlocked' : element.locked === false}]">
        <span v-if="element.isTemplateContentEdit" class="padlock-wrapper"><label :for="element.name"><Label :label="element.label" :tooltip="element.tooltip" /></label><Lock :locked="element.locked" @toggleLocked="toggleLockedState($event)" /></span>
        <label v-else :for="element.name" class="lock"><Label :label="element.label" :tooltip="element.tooltip" /></label>

        <input autocomplete="off" type="text" :id="element.name" :placeholder="element.placeholder" v-model="inputValue" :disabled="element.disabled" :readonly="element.readonly" @focus="onInputFocusStandard" @blur="onInputBlurStandard" >
        <span class="error-message" v-if="error">{{error}}</span>
    </div>
</template>

<script>
    import {log} from "@/shared/utils";

    import Label from "@/components/form/label";
    import Lock from "@/components/form/lock";

    import {formElementMixin} from "@/components/mixins/formelement";

    export default {
        name: "Formelement_text",
        components: {Label, Lock},
        mixins: [formElementMixin],
        props: {
            element: {
                type: Object
            },
            value: {
                type: String
            },
            classString: {
                type: String
            }
        },
        computed: {
            inputValue: {
                get() { return this.value },
                set(inputValue) {this.$emit('input', inputValue)}
            }
        },
        updated() {
            log(["text element updated", this.element.name]);
        }
    }
</script>